import React, { createContext, useState, useEffect, useContext } from "react";
import { toast } from "react-hot-toast";

const UserCart = createContext();

export function useCart() {
  return useContext(UserCart);
}

export function CartContext({ children }) {
  const [usercart, setCart] = useState([]);
  const [cartTotal, setCartTotal] = useState([]);

  //   offfline cart

  const getElementsfromLocalStorage = () => {
    let elements = [];
    if (localStorage.getItem("cart")) {
      elements = JSON.parse(localStorage.getItem("cart"));
      setCart(elements);
      const count = JSON.parse(localStorage.cart).length;
      setCartTotal(count);
    }
    return elements;
  };

  //add to cart

  const store_data = (
    variant_id,
    quantity,
    title,
    item_price,
    image,
    minimum_order_quantity,
    rating,
    is_restro_open,
    vendor_id
  ) => {
    // Create the cart item using the passed values
    const cart_item = {
      image: image,
      title: title,
      sell_price: item_price,
      id: variant_id,
      qty: quantity,
      minimum_order_quantity: minimum_order_quantity,
      rating: rating,
      is_restro_open: is_restro_open,
      sub_total: Number(item_price) * Number(quantity), // Calculate the subtotal based on price and quantity
      vendor_id: vendor_id,
    };

    // Get the existing cart from localStorage (if it exists)
    let cart = localStorage.getItem("cart");
    cart = cart ? JSON.parse(cart) : [];

    // If the cart is not empty, validate vendor_id
    if (cart.length > 0) {
      const existing_vendor_id = cart[0].vendor_id;

      if (existing_vendor_id !== vendor_id) {
        toast.error("You cannot add items from different vendors to cart.");
        return cart;
      }

      // If vendor_id matches, check if the item is already present
      let is_item_present = false;
      for (let i = 0; i < cart.length; i++) {
        if (cart[i].id === variant_id) {
          // If the item is present, update its quantity and subtotal
          cart[i].qty = quantity;
          cart[i].sub_total = Number(cart[i].sell_price) * Number(quantity); // Recalculate the subtotal
          is_item_present = true;
          toast.success("Item quantity updated in cart");
          break;
        }
      }

      // If the item was not found, add it to the cart
      if (!is_item_present) {
        cart.push(cart_item);
        toast.success("Item added to cart");
      }
    } else {
      // If the cart is empty, add the first item
      cart.push(cart_item);
      toast.success("Item added to cart");
    }

    // Store the updated cart in localStorage
    localStorage.setItem("cart", JSON.stringify(cart));
    return cart; // Return the updated cart if needed
  };


  // remove a specific product from the cart
  const removeProductFromCart = (product_variant_id) => {
    // Retrieve the current cart items from localStorage
    let cart = JSON.parse(localStorage.getItem("cart")) || [];

    // Filter out the item with the specified product_variant_id
    cart = cart.filter((item) => item.id !== product_variant_id);

    // Update the cart in localStorage
    localStorage.setItem("cart", JSON.stringify(cart));

    // Optionally, remove any related totals or other cart-specific data
    localStorage.removeItem("item_price");

    // Fetch the updated cart data
    getCartItemsFromLocalStorage();

    // Notify the user
    toast.success("Item removed from cart successfully!");
  };

  // clear the offline cart
  const clearOfflineCart = () => {
    localStorage.removeItem("cart");
    localStorage.removeItem("item_price");
    setCart([]);
    setCartTotal(0);
    getCartItemsFromLocalStorage();
    toast.success("Cart cleared successfully!");
  };

  
  const getCartItemsFromLocalStorage = () => {
    return JSON.parse(localStorage.getItem("cart")) || [];
  };




  useEffect(() => {
    getElementsfromLocalStorage();
    // if (isLogin()) {
    //   get_cart();
    // }
    // // eslint-disable-next-line
  }, []);

  return (
    <UserCart.Provider
      value={{
        store_data,
        removeProductFromCart,
        getCartItemsFromLocalStorage,
        clearOfflineCart
      }}
    >
      {children}
    </UserCart.Provider>
  );
}
